import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { createToast, dismissToast } from './useBotpress.utils';
import useEventListener from '../../../foundation/hooks/use-event-listener/use-event-listener';
import { BOTPRESS_LOADED_EVENT, BOTPRESS_NOTIFICATION_CONTAINER_ID } from '../../constants';
export default function useBotpress() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  var botpressRef = useRef(null);
  var notifications = useRef(new Map());
  function handleBotpressLoaded() {
    botpressRef.current = window.botpress;
    setIsLoaded(true);
  }

  // Botpress related methods
  function botpressMethodWrapper(method) {
    if (botpressRef.current) {
      var _botpressRef$current;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      (_botpressRef$current = botpressRef.current)[method].apply(_botpressRef$current, args);
    }
  }
  function sendEvent() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    botpressMethodWrapper.apply(void 0, ['sendEvent'].concat(args));
  }
  function sendMessage() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    botpressMethodWrapper.apply(void 0, ['sendMessage'].concat(args));
  }
  function openChat() {
    botpressMethodWrapper('open');
  }
  function closeChat() {
    botpressMethodWrapper('close');
  }
  function toggleChat() {
    botpressMethodWrapper('toggle');
  }

  // Notification related methods
  function dismissAllNotifications() {
    notifications.current.forEach(function (_ref) {
      var toastId = _ref.toastId;
      dismissToast(toastId);
    });
    notifications.current.clear();
  }
  function removeNotification(messageId) {
    notifications.current["delete"](messageId);
  }
  function addNotification(messageId, toastId, content) {
    notifications.current.set(messageId, {
      toastId: toastId,
      content: content
    });
  }
  function onNotificationClose(options, messageId) {
    if (messageId) {
      removeNotification(messageId, notifications);
    }
    if (options.onClose) {
      options.onClose();
    }
    dismissAllNotifications(notifications);
  }
  function getNotificationContainer() {
    if (typeof document !== 'undefined') {
      return document.querySelector("#".concat(BOTPRESS_NOTIFICATION_CONTAINER_ID));
    }
    return null;
  }
  function hideContainer() {
    var container = getNotificationContainer();
    if (container) {
      container.style.visibility = 'hidden';
    }
  }
  function showContainer() {
    var container = getNotificationContainer();
    if (container) {
      container.style.visibility = 'visible';
    }
  }
  function notify(content) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$messageId = options.messageId,
      messageId = _options$messageId === void 0 ? uuidv4() : _options$messageId;
    var callbacks = {
      onNotificationClose: onNotificationClose,
      addNotification: addNotification
    };
    if (!notifications.current.has(messageId)) {
      return createToast(content, options, messageId, callbacks);
    }
    return notifications.current.get(messageId).toastId;
  }
  useEffect(function () {
    return function () {
      dismissAllNotifications(notifications);
    };
  }, []);
  useEventListener(BOTPRESS_LOADED_EVENT, handleBotpressLoaded);
  return {
    isLoaded: isLoaded,
    sendEvent: sendEvent,
    sendMessage: sendMessage,
    openChat: openChat,
    closeChat: closeChat,
    toggleChat: toggleChat,
    notify: notify,
    hideContainer: hideContainer,
    showContainer: showContainer,
    dismissAllNotifications: dismissAllNotifications
  };
}